import { render, staticRenderFns } from "./AssinaturaModalPCM.vue?vue&type=template&id=a8cc90d8"
import script from "./AssinaturaModalPCM.vue?vue&type=script&lang=js"
export * from "./AssinaturaModalPCM.vue?vue&type=script&lang=js"
import style0 from "./AssinaturaModalPCM.vue?vue&type=style&index=0&id=a8cc90d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports